<template>
  <div :id="id" class="mx-3 mt-4 rounded-lg  text-right save-button-text">
    <b-button :disabled="busy" pill variant="link" @click="$emit('dirtyCheck')">Discard</b-button>
    <b-button
      v-if="!isForms"
      :disabled="busy"
      pill
      variant="outline-primary"
      @click="$emit('save', 'saveDraft')"
    >
      Save Draft
    </b-button>
    <b-button
      :disabled="busy"
      class="pr-5 pl-5"
      pill
      style="background: #585DF3; border-radius: 24px;"
      @click="submit()"
    >
      Submit
    </b-button>
  </div>
</template>
<script>
  export default {
    props: ['busy', 'id', 'isReadOnly'],
    computed: {
      isForms() {
        return this.$route.name === 'form-create';
      },
    },
    methods: {
      submit() {
        if (this.isForms) {
          this.$bvModal.show('formPreview');
        } else {
          this.$emit('save', 'saveSubmit');
        }
      },
    },
  };
</script>
